import React from "react";
import { useTheme } from "@/context/ThemeContext";
import { Palette, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const OPTIONS = [
  { id: "indigo", name: "Modern Indigo", hint: "Premium dark SaaS", swatch: ["#4F46E5", "#8B5CF6", "#0B0F19"] },
  { id: "green", name: "Fresh Green", hint: "Warm & natural", swatch: ["#34D399", "#2DD4BF", "#022C22"] },
  { id: "mono", name: "Neutral Mono", hint: "Clean & minimal · light", swatch: ["#171717", "#737373", "#FAFAFA"] },
  { id: "mono-dark", name: "Neutral Dark", hint: "Vercel-style · dark", swatch: ["#FAFAFA", "#A3A3A3", "#0D0D0D"] },
];

export default function ThemeSwitcher({ variant = "ghost", size = "icon" }) {
  const { theme, setTheme } = useTheme();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="theme-switcher-trigger"
          variant={variant}
          size={size}
          className="rounded-2xl"
          aria-label="Change theme"
        >
          <Palette className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 rounded-2xl">
        <DropdownMenuLabel className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">
          Theme
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {OPTIONS.map((o) => (
          <DropdownMenuItem
            key={o.id}
            data-testid={`theme-option-${o.id}`}
            onClick={() => setTheme(o.id)}
            className="flex items-center gap-3 py-3 cursor-pointer rounded-xl"
          >
            <div className="flex -space-x-1">
              {o.swatch.map((c, i) => (
                <span key={i} className="h-4 w-4 rounded-full border border-border" style={{ background: c }} />
              ))}
            </div>
            <div className="flex-1">
              <div className="text-sm font-medium">{o.name}</div>
              <div className="text-xs text-muted-foreground">{o.hint}</div>
            </div>
            {theme === o.id ? <Check className="h-4 w-4 text-primary" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
